<template>
  <div
    id="share-element"
    class="m-winning-share-container"
  >
    <div class="share-amount">
      {{ $t('CURRENCY_UNIT') }} {{ showTotalWinnings }}
    </div>
    <div class="share-msg">
      From {{ fromTypeText }}, Ticket ID: {{ shortId }}
    </div>
    <div class="share-footer">
      <div class="share-footer-left">
        <img
          class="share-footer-logo"
          src="~public/images/logo/logo.png"
          alt="MSport"
        >
      </div>
      <div class="share-footer-mid" />
      <p class="share-footer-host">
        {{ hostname }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ShareWinning',
  props: {
    fromTypeText: {
      type: String,
      default: ''
    },
    shortId: {
      type: String,
      default: ''
    },
    showWinnings: {
      type: Number,
      default: 0
    },
    hideMount: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    showTotalWinnings() {
      return this.hideMount ? '****' : this.showWinnings
    },
    hostname() {
      return location.hostname
    }
  }
}
</script>

<style lang="less">
@import url("~wap/common/style/variable.less");

#share-element {
  position: absolute;
  right: 10000px;
}

.m-winning-share-container {
  width: 330/@rem;
  height: 416/@rem;
  box-sizing: border-box;
  padding: 242/@rem 10/@rem 0;
  border-radius: 8/@rem;
  background: url("../images/winning/share-bg.png") no-repeat center / 100% 100%;
  color: #464546;
  font-size: 16/@rem;
  text-align: center;

  .share-amount {
    margin-bottom: 7/@rem;
    font-size: 32/@rem;
    font-weight: bold;
    line-height: 44/@rem;
  }

  .share-footer {
    position: absolute;
    bottom: 10/@rem;
    left: 0;
    display: flex;
    width: 100%;
    height: 30/@rem;
    box-sizing: border-box;
    align-items: center;
    justify-content: space-between;
    padding: 0 15/@rem;
    font-size: 12/@rem;

    &-mid {
      width: 1px;
      height: 100%;
      background-color: @disabled;
    }

    &-host,
    &-left {
      width: 49%;
    }

    &-logo {
      width: 110/@rem;
    }
  }
}

</style>
